import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';

interface WeddingWebsiteStorageData {
  clickedSection?: string;
}

export const WeddingWebsiteStorage = BasicStorageManager<WeddingWebsiteStorageData>({
  storageKey: 'wedding-websites',
});
